import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AttendeeCircle from './attendee-circle-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;
    const fill = validProps.fill || colors.offWhiteDk;

    return <AttendeeCircle {...validProps} fill={fill} />;
}

SvgComponent.iconName = 'attendeeCircle';

export const AttendeeCircleIcon = svgIconWrapper(SvgComponent);
